// collection-filters.js

const STOREFRONT_ACCESS_TOKEN = '556fb0b14947bff242f03399818f29cd';
const STOREFRONT_API_ENDPOINT = 'https://gentlegiantofficial.com/api/2023-07/graphql.json';

// Fixed Massimo order
const MASSIMO_ORDER = [
  'Massimo Silver',
  'Massimo Silver Leather',
  'Massimo Gold',
  'Massimo Gold Leather',
  'Massimo Two Tone',
  'Massimo Rose Gold',
  'Massimo Rose Gold Leather',
  'Massimo Black Leather'
];

async function fetchProductsWithMetafields() {
  const query = `
    {
      products(first: 50, query: "collection:watches") {
        edges {
          node {
            id
            title
            handle
            onlineStoreUrl
            featuredImage { url }
            priceRange { minVariantPrice { amount currencyCode } }
            metafield_watch_category: metafield(namespace: "custom", key: "watch_category") { value }
            metafield_features: metafield(namespace: "custom", key: "features") { value }
            metafield_material: metafield(namespace: "custom", key: "material") { value }
            metafield_band_material: metafield(namespace: "custom", key: "band_material") { value }
            metafield_band_color: metafield(namespace: "custom", key: "band_color") { value }
            metafield_dial_color: metafield(namespace: "custom", key: "dial_color") { value }
          }
        }
      }
    }
  `;
  const res = await fetch(STOREFRONT_API_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN,
    },
    body: JSON.stringify({ query }),
  });
  const data = await res.json();
  if (!data.data || !data.data.products) {
    console.error('Storefront API error:', data);
    if (data.errors) {
      data.errors.forEach((err, i) => {
        console.error(`Error ${i + 1}:`, err.message, err.extensions || '');
      });
    }
    alert('Error fetching products. See console for details.');
    return [];
  }
  return data.data.products.edges.map(edge => edge.node);
}

// Comment out the JS grid rendering on page load
// document.addEventListener('DOMContentLoaded', async function () {
//   const filterForm = document.getElementById('custom-filters-form');
//   const gridContainer = document.querySelector('.watches-collections');
//   const modal = document.getElementById('filters-drawer');
//   const sortSelect = filterForm.querySelector('select[name="sort_by"]');
//   const subSections = document.querySelectorAll('.sub-collection-section');
//
//   let allProducts = [];
//
//   // Fetch and render the JS grid on page load
//   allProducts = await fetchProductsWithMetafields();
//   allProducts = dedupeProducts(allProducts);
//   // Use fixed Massimo order for initial render
//   renderGrid(fixedMassimoOrder(allProducts));
//   // Hide the Liquid grid by default
//   var liquidGrid = document.getElementById('liquid-massimo-grid');
//   if (liquidGrid) liquidGrid.style.display = 'none';
//
//   // ...rest of the event listeners and logic...
// });

// Get selected filter values (multi-select)
function getSelectedFilters() {
  const filters = {};
  filterForm.querySelectorAll('input[type="checkbox"]').forEach(input => {
    if (input.checked) {
      if (!filters[input.name]) filters[input.name] = [];
      filters[input.name].push(input.value);
    }
  });
  return filters;
}

// Helper to get metafield value by key
function getMetafield(product, namespace, key) {
  // Map namespace/key to the aliased field names
  const map = {
    'custom.watch_category': 'metafield_watch_category',
    'custom.features': 'metafield_features',
    'custom.material': 'metafield_material',
    'custom.band_material': 'metafield_band_material',
    'custom.band_color': 'metafield_band_color',
    'custom.dial_color': 'metafield_dial_color',
  };
  const field = map[`${namespace}.${key}`];
  return product[field]?.value || null;
}

// Filter products by metafields
function filterProducts(products, filters) {
  return products.filter(product => {
    let match = true;
    for (const key in filters) {
      let ns, metaKey;
      if (key.startsWith('custom.')) {
        ns = 'custom';
        metaKey = key.replace('custom.', '');
      } else if (key.startsWith('shopify.')) {
        ns = 'shopify';
        metaKey = key.replace('shopify.', '');
      } else {
        continue;
      }
      const value = getMetafield(product, ns, metaKey);
      if (!value || !filters[key].includes(value)) {
        match = false;
        break;
      }
    }
    return match;
  });
}

// Custom sort to ensure Massimo Gold appears before Massimo Two Tone
function customMassimoSort(products) {
  // Find indices
  const goldIndex = products.findIndex(p => p.title && p.title.toLowerCase().includes('massimo gold'));
  const twoToneIndex = products.findIndex(p => p.title && p.title.toLowerCase().includes('massimo two tone'));
  if (goldIndex !== -1 && twoToneIndex !== -1 && goldIndex > twoToneIndex) {
    // Swap them
    const temp = products[goldIndex];
    products[goldIndex] = products[twoToneIndex];
    products[twoToneIndex] = temp;
  }
  return products;
}

function fixedMassimoOrder(products) {
  // Sort by MASSIMO_ORDER, then by original order for others
  const orderMap = MASSIMO_ORDER.reduce((acc, name, idx) => {
    acc[name.toLowerCase()] = idx;
    return acc;
  }, {});
  return [
    ...products.filter(p => MASSIMO_ORDER.some(name => p.title && p.title.toLowerCase() === name.toLowerCase()))
      .sort((a, b) => orderMap[a.title.toLowerCase()] - orderMap[b.title.toLowerCase()]),
    ...products.filter(p => !MASSIMO_ORDER.some(name => p.title && p.title.toLowerCase() === name.toLowerCase()))
  ];
}

// Sort products
function sortProducts(products, sortBy) {
  let sorted = [...products];
  if (sortBy === 'best-selling' || !sortBy) {
    // Always use fixed Massimo order for default/best-selling
    return fixedMassimoOrder(sorted);
  }
  switch (sortBy) {
    case 'price-ascending':
      sorted.sort((a, b) => parseFloat(a.priceRange.minVariantPrice.amount) - parseFloat(b.priceRange.minVariantPrice.amount));
      break;
    case 'price-descending':
      sorted.sort((a, b) => parseFloat(b.priceRange.minVariantPrice.amount) - parseFloat(a.priceRange.minVariantPrice.amount));
      break;
    case 'title-ascending':
      sorted.sort((a, b) => a.title.localeCompare(b.title));
      break;
    case 'title-descending':
      sorted.sort((a, b) => b.title.localeCompare(a.title));
      break;
    case 'created-descending':
      sorted.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      break;
    case 'created-ascending':
      sorted.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
      break;
    default:
      break;
  }
  return sorted;
}

// Render products in a single grid
function renderGrid(products) {
  subSections.forEach(sec => sec.style.display = 'none');
  let oldGrid = document.getElementById('dynamic-product-grid');
  if (oldGrid) oldGrid.remove();
  // Hide the Liquid grid
  var liquidGrid = document.getElementById('liquid-massimo-grid');
  if (liquidGrid) liquidGrid.style.display = 'none';
  const ul = document.createElement('ul');
  ul.className = 'sub-collection-grid';
  ul.id = 'dynamic-product-grid';
  products.forEach(product => {
    const li = document.createElement('li');
    li.className = 'product-card';
    li.innerHTML = `
      <a href="${product.onlineStoreUrl}">
        <div class="card-wrapper">
          <div class="card__media">
            <img src="${product.featuredImage ? product.featuredImage.url : ''}" alt="${product.title}" style="width:100%;height:auto;object-fit:cover;" />
          </div>
          <div class="card__content">
            <div class="card__heading">${product.title}</div>
            <div class="price">${product.priceRange.minVariantPrice.amount} ${product.priceRange.minVariantPrice.currencyCode}</div>
          </div>
        </div>
      </a>
    `;
    ul.appendChild(li);
  });
  gridContainer.appendChild(ul);
}

function showDefaultLayout() {
  subSections.forEach(sec => sec.style.display = '');
  let oldGrid = document.getElementById('dynamic-product-grid');
  if (oldGrid) oldGrid.remove();
  // Show the Liquid grid
  var liquidGrid = document.getElementById('liquid-massimo-grid');
  if (liquidGrid) liquidGrid.style.display = '';
}

// Helper to deduplicate products by id
function dedupeProducts(products) {
  const seen = new Set();
  return products.filter(product => {
    if (seen.has(product.id)) return false;
    seen.add(product.id);
    return true;
  });
}

async function handleFilterSort(e) {
  if (e) e.preventDefault();
  if (!allProducts.length) allProducts = await fetchProductsWithMetafields();
  allProducts = dedupeProducts(allProducts);
  const filters = getSelectedFilters();
  let filtered = filterProducts(allProducts, filters);
  const sortBy = sortSelect.value;
  if (sortBy !== 'best-selling') {
    filtered = sortProducts(filtered, sortBy);
    renderGrid(filtered);
  } else {
    showDefaultLayout();
  }
  if (modal) modal.style.display = 'none';
}

filterForm.addEventListener('submit', handleFilterSort);
sortSelect.addEventListener('change', handleFilterSort);
filterForm.addEventListener('reset', function(e) {
  setTimeout(() => {
    showDefaultLayout();
    if (modal) modal.style.display = 'none';
  }, 10);
}); 